/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { defineAbilityFor } from "./roles";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const SERVICE_NAME = "AppNavigatorService.AbilityService";
const log: any = LoggerModule.getInstance();

interface IAbilityCheckProps {
  whoami: string;
  sub: string;
  action: "create" | "read" | "update" | "delete";
}

export interface IAbilityMethods extends IPluginMethodMap {
  abilityCheckSync(args: IAbilityCheckProps): boolean;
}

export class AbilityService implements IAgentPlugin {
  readonly methods: IAbilityMethods;

  constructor() {
    this.methods = {
      abilityCheckSync: this.abilityCheck.bind(this),
    };
  }

  abilityCheck(args: IAbilityCheckProps): boolean {
    const { whoami, sub, action = "read" } = args;
    const ability: any = defineAbilityFor(whoami);
    if (ability) {
      const able = ability.can(action, sub);
      log.blue(
        SERVICE_NAME,
        `actor: ${whoami}, sub: ${sub}, action: read, able: ${able}`
      );
      return able;
    }
    return false;
  }
}
